<template>
  <div class="change-child-container">
    <div class="title">
      <span>请选择宝贝</span>
    </div>
    <div :class="checkdedChildId === item.id? 'child-list-checked':'child-list'" v-for="(item) in childrenList" :key="item.id" @click="onChooseChild(item)">
      <img class="child-head" :src="item.avatarUrl"/>
      <span class="child-name">{{item.englishName}}</span>
      <button :class="checkdedChildId === item.id? 'child-icon-checked': 'child-icon'"></button>
    </div>
    <div class="seize-seat-container"/>
    <div class="footer">
      <button @click="onConfirm()">确认</button>
    </div>
  </div>
</template>

<script>
import cookie from 'js-cookie'
import referralUri from '@/utils/_annual-report'
import { ACTIVITYCODE, CHANNELID, ORDERLIST } from '@/config/conferenceqrcode.js'
import { getStudentList } from '@/api/account.js'
import gateway from '@/_gateway.config'
import { getOrderInfo } from '@/api/conference-qrcode'
export default {
  data () {
    return {
      childrenList: null,
      checkedChildInfo: null,
      checkdedChildId: null
    }
  },
  async created () {
    const parentId = cookie.get('mbparentid')
    const studentId = cookie.get('mbstudentid')
    if (parentId) {
      let res = await getStudentList({ parentId })
      if (res.code === 200) {
        this.childrenList = res.data || []
        if (this.childrenList.length === 1) {
          this.$router.redirect({
            name: 'conferenceQRCode',
            query: {
              studentId: studentId
            }
          })
        }
      } else {
        this.$notify({ type: 'warning', message: res.message })
      }
    } else {
      cookie.remove('mbparentid')
      window.location.href = referralUri(CHANNELID, ACTIVITYCODE)
    }
  },
  methods: {
    onChooseChild (data) {
      this.checkedChildInfo = data
      this.checkdedChildId = data.id
    },
    onConfirm () {
      cookie.set('mbstudentid', this.checkedChildInfo.id, {
        domain: gateway.domain
      })
      getOrderInfo(this.checkedChildInfo.id).then(res => {
        if (res.data) {
          this.$router.push({
            name: 'conferenceQRCode',
            query: {
              studentId: this.checkedChildInfo.id
            }
          })
        } else {
            window.location.href = ORDERLIST
        //   this.$router.push({
        //     name: 'acTouch',
        //     query: {
        //       channelId: CHANNELID,
        //       activityCode: ACTIVITYCODE
        //     }
        //   })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.change-child-container {
  min-height: 100vh;
  background: #ffffff;
  margin: 80px 48px 0 48px;
}
.title {
  height: 60px;
  font-size: 44px;
  font-weight: 500;
  text-align: left;
  color: #333333;
  line-height: 60px;
  margin-bottom: 32px;
}
.child-list,.child-list-checked {
  height: 160px;
  background: #ffffff;
  border: 2px solid #f1f2f3;
  border-radius: 18px;
  display: flex;
  margin-bottom: 24px;
}
.child-list-checked {
  background: #FFF6F2;
  border: 2px solid #ff6422;
}
.child-head {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  margin: 32px 24px 32px 32px;
}
.child-name {
  font-size: 32px;
  font-weight: 600;
  text-align: left;
  color: #333333;
  line-height: 44px;
  letter-spacing: 0px;
  line-height: 160px;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.child-icon,.child-icon-checked {
  width: 48px;
  height: 48px;
  background: url("~@/assets/img/conference-qrcode/change-child-unclick.png") no-repeat;
  background-size:100% 100%;
  float: right;
  margin: 56px 32px 56px 0;
}
.child-icon-checked {
  background: url("~@/assets/img/conference-qrcode/change-child-click.png") no-repeat;
  background-size:100% 100%;
}
.seize-seat-container {
  width: 100%;
  height: 188px;
}
.footer {
  position: fixed;
  left: 50%;
  bottom: 0px;
  transform: translate(-50%,0);
  width: 690px;
  height: 188px;
  background-color: #FFFFFF;
  z-index: 9999;
  button {
    width: 690px;
    height: 80px;
    background: #ff6422;
    border-radius: 202px;
    font-size: 32px;
    font-weight: 400;
    text-align: center;
    color: #ffffff;
    line-height: 36px;
    margin-top: 19px;
  }
}
</style>
